import { Card, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { FinalReportPlannerVisitProjectFragment } from "../../fragment.generated";
import FinalReportObservationTable from "./FinalReportObservationTable";
import {
    FinalReportObservationsTableItemFragment,
    PreciseLocationFormFragment,
} from "./FinalReportObservationTableItem/fragment.generated";

type Props = {
    observations: FinalReportObservationsTableItemFragment[];
    preciseLocationForm: PreciseLocationFormFragment;
    project: FinalReportPlannerVisitProjectFragment;
};

export default function FinalReportObservationsCard({ observations, preciseLocationForm, project }: Props) {
    const { t } = useTranslation("project");
    return (
        <Card sx={{ padding: 2 }} variant="outlined">
            <Typography variant="h5">{t("projectReviewVisitV2.finalReportRoute.finalReportObservationsCard.title")}</Typography>
            {observations.length === 0 && (
                <Typography>{t("projectReviewVisitV2.finalReportRoute.finalReportObservationsCard.noObservations")}</Typography>
            )}
            <FinalReportObservationTable
                observations={observations}
                preciseLocationForm={preciseLocationForm}
                project={project}
            />
        </Card>
    );
}
